export default function removeDoubleSlashes(url: string) {
  if (typeof url !== 'string' || url.length === 0) {
    return url;
  }
  try {
    const urlObj = new URL(url);
    urlObj.pathname = urlObj.pathname.replace(/\/\/+/g, '/');
    return urlObj.toString();
  } catch (error) {
    console.error('Error parsing URL with URL API. Attempting regex fallback:', error);
    return url.replace(/(?<!:)\/\/+/g, '/');
  }
}
